import { createEntityAdapter } from "@reduxjs/toolkit";
import { App } from "./dataTypes";

export const appAdapter = createEntityAdapter<App>({});
